/**
 * Checkout Block - Block Data
 *
 * @package YITH\AdvancedReviews\Modules\RequestReview\WCBlocks\Src\RequestReview
 */

import React from "react";
import {CheckboxControl} from '@woocommerce/blocks-checkout';

const Block = ({checked, onChange}) => {
	return (
		<div className="wc-block-checkout__ywar-request-review">
			<CheckboxControl
				id="yith-ywar-request-review"
				className={'request-review-block'}
				label={ywar_blocks.request_review_checkout}
				checked={checked}
				onChange={onChange}
			/>
		</div>
	);
};

export default Block;
